import { Box, styled } from '@mui/material';

export const RightComponentFooter = styled(Box)`
    display: flex;
    justify-content: center;
    flex: 60%;
`;
export const Footer = styled(Box)`
    padding: 0 70px;
    height: 80px;
    width: 100%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    flex-direction: row;
    border-top: 1px solid ${({ theme }) => theme.palette.blue.darkest};
`;
